import { Injectable } from "@angular/core";
import { ICustomErrorMatch } from "../../stores/custom-errors.store";

@Injectable()
export class CustomErrorDialogService {
    public static dialogComponentCallback: any;

    static show(match: ICustomErrorMatch): boolean {
        if (!CustomErrorDialogService.dialogComponentCallback) return false;
        try {
            (<any>CustomErrorDialogService.dialogComponentCallback).showCustomError(match);
            return true;
        }
        catch {
            return false;
        }
    }
}
